import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from "src/app/services/submitdata/submitdata.service";
import { isNullOrUndefined } from 'util';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import Highcharts from 'highcharts';
import {chartDatas,dataSubs,monthmaps} from 'src/assets/i18n/hi.json'

@Component({
  selector: 'app-dgc-meeting-reports',
  templateUrl: './dgc-meeting-reports.component.html',
  styleUrls: ['./dgc-meeting-reports.component.css']
})
export class DgcMeetingReportsComponent implements OnInit {
  yearDropDownList: any;
  dgcFilter: object = { 'montharray': '', 'ay': '' };
  userDetails: any;
  tableData: any;
  @Input() selectedlanguage:string;
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  chartData: any;
  initData: any;
  enableNgOnChanges: boolean;
  constructor(
    private submitdataservice: SubmitdataService,
    private translate: TranslateService,
    private constants: ConstantsModule,
    private loginsrv: AuthloginService) {
    translate.setDefaultLang('en');    
  }

  ngOnInit() {
    this.submitdataservice.getStatusOfToken();
    this.fetchAssesmentYear();
    this.userDetails = this.loginsrv.checkloginstatus();
    this.getReportData();
  }

  ngOnChanges(){
    if(this.enableNgOnChanges){
      this.formatDataForCharts();
    }
  }

  fetchAssesmentYear() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data => {
      this.yearDropDownList = data['data'];
    })
    this.dgcFilter['ay'] = dropDownYear;
  }

  getReportData() {
    let postdata = {
      "ay": this.dgcFilter['ay'],
      "lu": this.userDetails['loggedUserData']['userProfile']['locationId'],
    }
    this.submitdataservice.getDGCMeetingReport(postdata).subscribe(data => {
      if (!isNullOrUndefined(data) && data['status']) {
        this.initData = data['data'];
        this.formatTableData(data['data']);
        this.formatDataForCharts();
        this.enableNgOnChanges = true;
      }
    })

  }

  formatTableData(data) {
    this.tableData = [];
    this.monthList.forEach(month => {
      Object.keys(data).forEach(dataobj => {
        let number = dataobj.substring(4, 6);
        let item = {};
        if (month.key == number) {
          item['month'] = month.value;
          item['status'] = data[dataobj];
          this.tableData.push(item);
        }
      })
    })
  }

  formatDataForCharts() {
    let data = this.initData;
    this.chartData = [];
    this.monthList.forEach(month => {
      Object.keys(data).forEach(dataobj => {
        let number = dataobj.substring(4, 6);
        if (month.key == number) {
          let item = {};
          item['name'] = this.selectedlanguage == 'en'? month['value'] : monthmaps[month.value];
          if (data[dataobj] == 'Submitted') {
            item['y'] = 1;
            item['status'] = this.selectedlanguage == 'en'? 'Submitted' : 'प्रस्तुत';
          } else if (data[dataobj] == 'Pending') {
            item['y'] = 0;
            item['status'] = this.selectedlanguage == 'en'? 'Pending' : 'लंबित';
          }
          this.chartData.push(item);
        }
      })
    })

    this.createSingleColmnChart();
  }

  createSingleColmnChart() {
    let chartTitle = "DGC's submitted status";
    let xaxislablesEn = ['April','May','June','July','August','September','October','November','December','January','February','March'];
    let xaxislablesHi = ['अप्रैल','मई','जून','जुलाई','अगस्त','सितम्बर','अक्टूबर','नवंबर','दिसंबर','जनुअरी','फेब्रुअरी','मार्च'];
    Highcharts.chart('single-column-chart', {
      chart: {
        type: 'column'
      },
      title: {
        text: this.selectedlanguage == 'en'? chartTitle: chartDatas["DGCs submitted status"]
      },
      xAxis: {
        categories: this.selectedlanguage == 'en'? xaxislablesEn : xaxislablesHi,
        // type: 'category',
        title: {
          text: this.selectedlanguage == 'en'? 'Months':dataSubs.months,
          style: {
            fontSize: '20px',
            color: 'black'
          }
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        }
      },
      yAxis: {
        title: {
          text: this.selectedlanguage == 'en'? "Status" : dataSubs.status,
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '14px'
          },
          formatter: this.selectedlanguage == 'en'? function () {let yaxisLabelsE = ['Non submitted', 'Submitted'];
            return yaxisLabelsE[this.pos] } : function () {let yaxisLabelsH = ['प्रस्तुत नहीं किया गया', 'प्रस्तुत'];
            return yaxisLabelsH[this.pos] }
        }
      },
      tooltip: {
        useHTML: true,
        headerFormat: `<div>{point.key}</div>`,
        pointFormat: `{point.status}`        
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false,
        //   useHTML:true,
        //   labelFormatter: function() {
        //     let legendGreen = '<div>' +
        //     '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "green" +'; display: inline-block; margin-right:5px"></div>' +
        //     "<span>" + "Meeting > 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
        //     '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "yellow" +'; display: inline-block; margin-right:5px"></div>' +
        //     "<span>" + "Meeting 50% to 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
        //     '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "red" +'; display: inline-block; margin-right:5px"></div>' +
        //     "<span>" + "Meeting 0% to 49.99%" + "</span>" +
        // '</div>'
        //     // '<div><div style="border-radius: 50%; width: 10px; height: 10px; background-color: "green"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 99%' + '</div>' 
        //     // +'<div style="border-radius: 50%; width: 10px; height: 10px; background-color:"yellow"; display: inline-block; margin-right:5px"> </div>' + '<span class="symbol" style="background-color: green; width: 13px; height: 13px;"></span>' + ' meeting 59%' + '</div></div>';
        //     return legendGreen
        //   },
        //     symbolHeight: '0px'
      },
      // plotOptions:{
      // },
      // exporting : {
      //   allowHTML: true
      // },
      series: [{
        data: this.chartData,
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

}
